import { render, staticRenderFns } from "./DrugEdit.vue?vue&type=template&id=c6f148a4&scoped=true"
import script from "./DrugEdit.vue?vue&type=script&lang=js"
export * from "./DrugEdit.vue?vue&type=script&lang=js"
import style0 from "../../../sass/pharmacy/editPharmacy.scss?vue&type=style&index=0&id=c6f148a4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f148a4",
  null
  
)

export default component.exports